import LoginError from './LoginError';
class InvalidVerificationCode extends LoginError {
    constructor(options) {
        super('Verification code is invalid', options);
    }
}
export default InvalidVerificationCode;
